const state = {
  token: '',
  name: '',
  openId: '',
  url: '',
  jf: ""
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_OPENID: (state, openId) => {
    state.openId = openId
  },
  SET_URL: (state, url) => {
    console.log(url, 'urlurl111')
    state.url = url
  },
  SET_JF: (state, jf) => {
    console.log(jf, 'jfjfjfjfjf')
    state.jf = jf
  },
}

const actions = {
  setopenid({ commit }, { openid }) {
    commit('SET_OPENID', openid)
  },
  seturl({ commit }, { url }) {
    commit('SET_URL', url)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
